import $ from 'jquery';
import {Foundation} from 'foundation-sites/js/foundation.core';

Foundation.addToJquery($);

// Import styles
import '../sass/public-page.scss';

import {Orbit} from 'foundation-sites/js/foundation.orbit';

Foundation.plugin(Orbit, 'Orbit');

export {Foundation};



// WEBPACK FOOTER //
// ./src/resources/js/publicPage.js